import { useEffect, useState } from "react";
import { COUNTRIES, detectCountry } from "@/lib/currency";
import { MapPin } from "lucide-react";

const inputCls = "mt-1.5 w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-orange-500";
const labelCls = "text-xs font-medium uppercase tracking-wider text-slate-400";

export const LocationCurrency = ({ form, setForm }) => {
  const [detected, setDetected] = useState(false);

  useEffect(() => {
    if (!form.country) {
      const c = detectCountry();
      if (c) {
        setForm((f) => ({ ...f, country: c.code, currency_symbol: c.symbol }));
        setDetected(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pickCountry = (code) => {
    const c = COUNTRIES.find((x) => x.code === code);
    setDetected(false);
    setForm((f) => ({ ...f, country: code, currency_symbol: c ? c.symbol : f.currency_symbol }));
  };

  return (
    <div className="border-t border-b border-slate-800 py-6 space-y-4" data-testid="location-currency-section">
      <div>
        <p className="text-sm font-semibold flex items-center gap-1.5"><MapPin className="h-4 w-4 text-orange-400" /> Location &amp; currency</p>
        <p className="text-xs text-slate-400">Your country sets the currency shown on your menu, orders and insights.</p>
      </div>
      <div>
        <label className={labelCls}>Address of operation</label>
        <input data-testid="branding-address-input" maxLength={200} value={form.address} onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))} placeholder="Street, city, postcode" className={inputCls} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-[1fr_140px] gap-4">
        <div>
          <label className={labelCls}>Country</label>
          <select data-testid="branding-country-select" value={form.country} onChange={(e) => pickCountry(e.target.value)} className={inputCls}>
            <option value="">Select country</option>
            {COUNTRIES.map((c) => <option key={c.code} value={c.code}>{c.name} ({c.symbol})</option>)}
          </select>
          {detected && <p data-testid="country-detected-hint" className="text-xs text-orange-300 mt-1.5">Detected {COUNTRIES.find((c) => c.code === form.country)?.name} ({form.currency_symbol}) from your location. Pressing Save changes your menu prices to {form.currency_symbol}.</p>}
        </div>
        <div>
          <label className={labelCls}>Currency symbol</label>
          <input data-testid="branding-currency-input" required maxLength={5} value={form.currency_symbol} onChange={(e) => setForm((f) => ({ ...f, currency_symbol: e.target.value }))} className={`${inputCls} font-mono-j`} />
        </div>
      </div>
    </div>
  );
};
